import { Shield, Zap, Activity } from 'lucide-react';

export interface PricingTier {
  id: string;
  name: string;
  description: string;
  monthlyPrice: string;
  yearlyPrice: string;
  originalPrice: string;
  monthlySubText: string;
  yearlySubText: string;
  yearlyBillingTotal: string;
  features: string[];
  icon: any;
  color: string;
  accentColor: string;
  popular?: boolean;
  trialPrice?: string;
  trialDuration?: string;
}

export const PRICING_TIERS: PricingTier[] = [
  {
    id: 'FREE',
    name: 'Starter Studio',
    description: 'Basic access to explore our ball engine.',
    monthlyPrice: 'Free',
    yearlyPrice: 'Free',
    originalPrice: '',
    monthlySubText: 'Forever',
    yearlySubText: 'Forever',
    yearlyBillingTotal: '',
    features: [
      '1 Mode Unlocked',
      'Standard render quality',
      '5 free exports/month',
      'Watermarked exports',
      'Basic support'
    ],
    icon: Shield,
    color: 'glass-cyan',
    accentColor: '#00e5ff',
  },
  {
    id: 'creator_pro',
    name: 'Pro Creator',
    description: 'Full creative suite for high-retention social content.',
    monthlyPrice: '$39',
    yearlyPrice: '$29',
    originalPrice: '$49.00',
    monthlySubText: 'Limited 20% Off Launch Offer',
    yearlySubText: 'Get Free Studio Elite Benefits for First Year',
    yearlyBillingTotal: '$348',
    features: [
      'All Modes Unlocked',
      'Unlimited exports',
      'Full HD / 4K exports',
      'Premium templates',
      'Commercial license',
      'No watermark',
      'Priority email support'
    ],
    icon: Zap,
    color: 'glass-panel',
    accentColor: '#06b6d4',
    popular: true,
    trialPrice: '$2.00',
    trialDuration: '3 days',
  },
  {
    id: 'studio_elite',
    name: 'Studio Elite',
    description: 'Custom Sound Engine that instantly make videos go viral.',
    monthlyPrice: '$159',
    yearlyPrice: '$119',
    originalPrice: '$199.00',
    monthlySubText: 'Limited 20% Off Launch Offer',
    yearlySubText: 'Billed annually ($1428)',
    yearlyBillingTotal: '$1428',
    features: [
      'Everything Unlocked',
      'Premium sound engine',
      'Custom Watermark',
      'Exclusive beta access',
      
      'Priority support',
      '3-Day Trial Available'
    ],
    icon: Activity,
    color: 'glass-amber',
    accentColor: '#ffea00',
    trialPrice: '$4.00',
    trialDuration: '3 days',
  }
];
